import { createContext, useContext } from "react";

type ContextValues = {
  publicationId: string,
  unitId: string,
};

const INITIAL_CONTEXT: ContextValues = {
  publicationId: "",
  unitId: "",
};


export const IdContext = createContext(INITIAL_CONTEXT);

export const useIdContext = () => useContext(IdContext);
